import { i18n } from '@/i18n';

export const ValidationMin = (min, label = 'validation.min') => (value) => {
  if (value === null || value === '') {
    return true;
  }
  if (Number(value) < min) {
    return i18n.t(label, { min });
  }
  return true;
};
